import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../../Util/Session/session.service';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultipleLocationGeoMappingServiceService {

  constructor( private http: HttpClient,
    private session: SessionService,) { }

  MultipleLocationGeoMapLoad(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `MultipleLocationGeoMappingLoad/Load`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  MultipleLocationGeoMapInsertUpate(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `MultipleGeoLocationMappingInsert/Update`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteGateGeoMapping_BlukInsert(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteGateGeoMapping_BlukInsert/Update`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
